import React from 'react';
import {
  IconFilter,
  FilterInputComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const IdentificationCodeFilter = () => (
  <IconFilter hasApplyButton name="identificationCode" as={FilterInputComponent} />
);

export default IdentificationCodeFilter;
